module.exports = __webpack_public_path__ + "img/5.feb4e5de.png";